import RequestBuilder from 'Resources/RequestBuilder';
import { MultiSelectContext } from 'App/components/MultiselectProvider/MultiselectProvider';
import openModal from 'App/services/Modal';

export default function scrapeCompanyWebsites(rb: RequestBuilder, entity: string, selected: MultiSelectContext) {
	return openModal('ScrapeCompanyWebsites', {
		rb,
		multiSelectContext: selected
	});
}
